var React = require('react');

function External (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st02{fill:#FFFFFF;}\n"),React.createElement("title",{"key":1},"external"),React.createElement("path",{"className":"st02","d":"M11.7,97.9l70-70v29.3c0,4.5,3.7,8.2,8.2,8.2c4.5,0,8.2-3.7,8.2-8.2V0h-8.3h-49c-4.5,0-8.2,3.7-8.2,8.2\n\ts3.7,8.2,8.2,8.2c0,0,0,0,0,0h29.3L0,86.5C0,90.4,0.2,94,0.1,97.9","key":2})]);
}

External.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 98.1 98","xmlSpace":"preserve"};

module.exports = External;

External.default = External;
